import MultiSelectInput from '@repo/ui/multiselect-input'
import RadioInput from '@repo/ui/radio-input'
import Typography from '@repo/ui/typography'

import {
  HobbyAudienceEnum,
  hobbyAudienceEnumMapping
} from '../../../lib/types/enums/hobby/hobby-audience.enum'
import { HobbiesFilter as HobbiesFilterType } from '../../../lib/types/models/hobby/hobby'

type Props = {
  filter?: HobbiesFilterType
  onFilterChange: (filter: HobbiesFilterType) => void
}

const HobbiesFilter = ({ filter, onFilterChange }: Props) => (
  <div className="mt-5 flex flex-col gap-4">
    <div className="flex flex-col gap-2">
      <Typography variant={'label-semibold'}>Créé automatiquement</Typography>

      <div className="flex flex-row gap-5">
        <RadioInput
          label={'Tous'}
          checked={filter?.automaticallyGenerated === undefined}
          onCheck={() => onFilterChange({ ...filter, automaticallyGenerated: undefined })}
        />

        <RadioInput
          label={'Oui'}
          checked={filter?.automaticallyGenerated === true}
          onCheck={() => onFilterChange({ ...filter, automaticallyGenerated: true })}
        />

        <RadioInput
          label={'Non'}
          checked={filter?.automaticallyGenerated === false}
          onCheck={() => onFilterChange({ ...filter, automaticallyGenerated: false })}
        />
      </div>
    </div>

    <MultiSelectInput
      label="Visible dans"
      variant="primary"
      options={Object.values(HobbyAudienceEnum).map((audience) => ({
        label: hobbyAudienceEnumMapping[audience],
        value: audience
      }))}
      onChange={(visibleTo) => onFilterChange({ ...filter, visibleTo })}
      selectedOptions={filter?.visibleTo?.map((audience) => ({
        label: hobbyAudienceEnumMapping[audience],
        value: audience
      }))}
    />
  </div>
)

export default HobbiesFilter
